import { render } from "./userGenderSelector.vue?vue&type=template&id=83f8dd02&scoped=true&ts=true"
import script from "./userGenderSelector.vue?vue&type=script&lang=ts"
export * from "./userGenderSelector.vue?vue&type=script&lang=ts"

import "./userGenderSelector.vue?vue&type=style&index=0&id=83f8dd02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f8dd02"]])

export default __exports__